import { Form, Formik } from 'formik';
import { CustomButton } from '../../components/CustomButton';
import { InputField } from '../../components/Reusable/NewFormik/Input1';
import logo from '../../assets/images/Platform Suite_Logo_White_LG.png';
import styled from '@emotion/styled';
import { AssigneeWrapper, FieldSet, InputWrapper, LinkWrapper } from '../../components/styles/FormStyles';
import Lottie from 'react-lottie';
import { defaultOptions } from '../../constants/LoaderDefaultOptions';
import useConfirmSignUp from '../../hooks/features/auth/useConfirmSignUp';

const AuthWrapper = styled.div`
  display: flex;
`;

const Links = styled.a`
  font-weight: 600;
  color: #4c6d66;
  cursor: pointer;
`;

export const LeftLogoContainer = styled.div`
  width: 50vw;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #26303e;
`;

const RightFormContainer = styled.div`
  width: 50vw;
  height: 100vh;
  overflow: auto;
`;
const LogoImage = styled.img`
  transform: translate(0, -25%);
  width: 27rem;
`;

const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
`;
const InputContainer = styled.div`
  width: 433px;
`;
const HeaderText = styled.div`
  font-weight: 600;
  font-size: 24px;
`;
const HeaderSubText = styled.div`
  font-size: 16px;
  line-height: 22px;
  color: #1c1c1c;
`;

export const CustomConfirmSignUpForm = () => {
  const { loading, validationSchema, confirmSignUp, alreadyConfirmed, token, initialValues, location, goToHomePage } =
    useConfirmSignUp();
  if (alreadyConfirmed) {
    return (
      <h3>
        User is already confirmed,Go back to <a href="/">Login Page</a>
      </h3>
    );
  } else if (token) {
    return <Lottie options={defaultOptions} width={500} height={500} />;
  }

  return location.state ? (
    <AuthWrapper>
      <LeftLogoContainer>
        <LogoImage src={logo} alt="logo" />
      </LeftLogoContainer>
      <RightFormContainer>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={confirmSignUp}
          enableReinitialize={true}
        >
          {({ setFieldValue, values, handleChange, touched, errors }) => {
            return (
              <Form id="confirmSignUp">
                <FormContainer>
                  <FieldSet>
                    <InputContainer>
                      <InputWrapper>
                        <HeaderText>Check your email</HeaderText>
                      </InputWrapper>
                      <InputWrapper>
                        <HeaderSubText>A user verification code will be sent to your email.</HeaderSubText>
                      </InputWrapper>
                      <InputWrapper>
                        <InputField
                          label="Email"
                          type="email"
                          disabled
                          name="email"
                          id="email"
                          onChange={handleChange}
                          value={values.email}
                          touched={touched.email}
                          errors={errors.email}
                        />
                      </InputWrapper>
                      <InputWrapper>
                        <InputField
                          label="User Verification Code"
                          placeholder="Enter Code"
                          name="code"
                          id="code"
                          value={values.code}
                          onChange={handleChange}
                          touched={touched.code}
                          errors={errors.code}
                          disabled={loading}
                        />
                      </InputWrapper>
                      <AssigneeWrapper>
                        <CustomButton disabled={loading} type="submit">
                          {loading ? 'Loading' : 'Verify'}
                        </CustomButton>
                        <LinkWrapper>
                          <Links onClick={() => goToHomePage()}>Go back to login page</Links>
                        </LinkWrapper>
                      </AssigneeWrapper>
                    </InputContainer>
                  </FieldSet>
                </FormContainer>
              </Form>
            );
          }}
        </Formik>
      </RightFormContainer>
    </AuthWrapper>
  ) : (
    <div>
      <h1>Ristricted Access</h1>
    </div>
  );
};
